module.exports = __webpack_public_path__ + "static/blog-bb701473b2ffc587f59f2da9759d78c1.jpg";